<template>
  <div class="pt-1 text-main-400">
    <span v-for="tag in video.tags" :key="tag.key" class="p-1">
      {{ tag.tag }}
    </span>
  </div>
</template>

<script>
import videoListItemContentMixin from '@/mixins/videoListItemContentMixin'

export default {
  mixins: [videoListItemContentMixin],
}
</script>
